<template>
	<div id="app">
		<div v-show="blocked" id="landscape_blocker">Merci de tourner votre écran !</div>
		<!-- <div class="debug_link" style="position: fixed; bottom: 0; left: 0"><router-link to="/debug">Go to debug view</router-link></div> -->
		<main>
			<transition name="fade" mode="out-in">
				<router-view></router-view>
			</transition>
		</main>
	</div>
</template>

<script>
export default {
	name: 'app',
	data: () => ({
		blocked: false
	}),
	mounted: function() {
		if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
		// true for mobile device
			this.checkLock();
			window.addEventListener('orientationchange', () => {
				this.checkLock();
			})
		}else{
		}
	},
	methods: {
		checkLock: function() {
			setTimeout(() => {
				console.log('check', window.innerHeight, window.innerWidth, window.innerHeight > window.innerWidth)
				if (window.innerHeight > window.innerWidth)
					this.blocked = false;
				else
					this.blocked = false;
			}, 100)
		}
	}
}

</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@200;500;600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Yeseva+One&display=swap');

$mainColor: #ED3B24;
$buttonLinkColor: #ED3B24; 
$buttonLinkColorDisabled: #878787;

/**
 * Transition entre pages
 */
.fade-enter-active,
.fade-leave-active {
	transition-duration: .15s;
	transition-property: opacity;
	transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0
}

body {
	margin: 0;
	padding: 0px;
	width: 100vw;
	height: 100vh;
	box-sizing: border-box;
}

#landscape_blocker {
	height: 100vh;
	width: 100vw;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	background-color: $mainColor;
	color: white;
	font-family: 'Poppins', sans-serif;
}

.page {
	height: 100%;
	width: 100%;
}

#app {
	font-family: 'Poppins', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	height: 100%;
	max-height: 100vh;
	overflow: hidden;
}


.boisRiquet {
	//text-decoration: underline;
	//text-decoration-color:red;
	font-family: 'Yeseva One', cursive;
	font-weight: 400;
	color: black;
	display:flex;
	justify-content:right;
	max-width: 100%;
	height: 50%;
	//margin: 10%;
	font-size: 2.5em;
	text-align:right;
	margin: 0%;
	margin-bottom: 20px;
	text-align: right;
}

#app .boisRiquet1 {
	font-family: 'Yeseva One', cursive;
	font-weight: 400;
	color: black;
	display:flex;
	justify-content:flex-end;
	max-width: 10%;
	height: auto;
	margin: 20px auto;

}

	.youtubeLink {
		margin-bottom: 20px;
	}

	.youtubeLink:last-child {
		margin-bottom: 30px;
	}

hr:after {
		background: red;
		position: relative;
		
}
img {
	max-width: 100%;
	height: auto;
}
h1{
	color:black;
	width:auto;
	height:auto;
}
h2{
	color: black;
}
h3{
	color:black;
	margin:40px;
}
h5{
	color: red;
}

.buttonLink {
	background-color: $buttonLinkColor;
	color: white;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	box-sizing: border-box;
	text-align: center;
	display: flex;
	justify-content:center;
	align-items:center;
	margin: 0 50px 10px;
	padding: 10px 20px;
	border-radius: 20px;
	text-decoration: none;
	font-size: larger;
	align-content:center;
	max-width: 70%;
	height: auto;

	&:disabled {
		background-color: $buttonLinkColorDisabled;
	}
} 
.buttonLink2 { // Boutons toujours gris
	background-color: $buttonLinkColorDisabled;
	display: block;
	padding: 10px 10px;
	margin-bottom:1em; 
} 


	#app hr {
	max-width: 100vw;
	max-width: 70%;
	height: auto;
	}

	main {
	 text-align: center;
	 height: 100%;
	 width: 100%;
	}

	button {
	 background: transparent;
	 box-shadow: 0px 0px 0px transparent;
	 border: 0px solid transparent;
	 text-shadow: 0px 0px 0px transparent;
	}

	button:hover {
	 background: transparent;
	 box-shadow: 0px 0px 0px transparent;
	 border: 0px solid transparent;
		text-shadow: 0px 0px 0px transparent;
	}

	button:active {
	 outline: none;
		border: none;
	}

	button:focus {  
	 outline: 0;
	}


  #app a, #app button {
    font-family: 'Poppins';
    font-weight: 300;
  }

// header {
//   margin: 0;
//   height: 56px;
//   padding: 0 16px 0 24px;
//   background-color: #35495E;
//   color: #ffffff;
// }

// header span {
//   display: block;
//   position: relative;
//   font-size: 20px;
//   line-height: 1;
//   letter-spacing: .02em;
//   font-weight: 400;
//   box-sizing: border-box;
//   padding-top: 16px;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue